(function () {

    angular
        .module('ngmvac')
        .directive('movilPromo', movilPromo); 

     

        function movilPromo() {
            return {
                restrict: 'A',
                template: '<div class="label-promocion spa" ng-repeat="item in ofertas | limitTo : 1"><i class="fa fa-gift gift-orange" aria-hidden="true"></i> {{item.name}}</div>',
                link: function (scope, element, attrs) {
              
                      var rooms = JSON.parse(attrs.movilPromo);
                   
                      var arr = [];
                        angular.forEach(rooms, function(room){
                            if(angular.isDefined(room.promotions)){
                            angular.forEach(room.promotions, function(promotion){
                                    arr.push(promotion);
                            });
                            }
                        });
                     scope.ofertas = arr;
                       
                }
            };
        }

})();